var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb8 training-model" },
    [
      _c("skill-detail", {
        staticClass: "mt20 training_model-detail",
        attrs: {
          "evaluation-detail": _vm.trainingSkill,
          loading: _vm.loading,
          scene: 2,
          fields: _vm.fields,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }